import React from 'react'
import {Link} from 'react-router-dom'

const Footer = () => (
    <footer>
        <div className="footer-link-wrapper">
            <Link to="/impressum">
                Impressum
            </Link>
        </div>

        <div className="footer-link-wrapper">
            <Link className="footer-link" to="/data-protection">
                Datenschutz
            </Link>
        </div>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js